export const useFileDownload = () => {
  const downloadBlob = (data: any, fileName: string) => {
    const url = window.URL.createObjectURL(new Blob([data]))
    createDownloadLink(url, fileName)
  }

  const createDownloadLink = (data: string, fileName: string) => {
    const link = document.createElement('a')
    link.href = data
    link.target = '_blank'
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  return { downloadBlob, createDownloadLink }
}
